import styled from 'styled-components';
export const FontOption = styled.span.withConfig({
  displayName: "FontOption",
  componentId: "cn18x3-0"
})(({
  fontFamily,
  cssStyles
}) => {
  return Object.assign({
    fontFamily
  }, cssStyles);
});